import { DocumentData, Loader } from '@ysura/common';

import { HTMLFile, HTMLZIPFile, PDFFile } from '@/components/DocumentPreview';
import { useInteraction } from '@/hooks';
import { DocumentType, DownloadedDocument } from '@/services/api';

type DocumentPreviewContentProps = {
  documentName: string;
  document: DownloadedDocument;
  documentMetadata: DocumentData;
  isDownloadButtonShown?: boolean;
  isInInteraction?: boolean;
  onClose: VoidFunction;
};

export const DocumentPreviewContent = ({
  documentName,
  document,
  documentMetadata,
  isDownloadButtonShown = true,
  isInInteraction = false,
  onClose,
}: DocumentPreviewContentProps) => {
  const { currentPageSharingMedia } = useInteraction();

  if (document.mediaType === DocumentType.PDF) {
    return (
      <PDFFile
        data={document.data}
        fileName={documentName}
        isDownloadButtonShown={isDownloadButtonShown}
        isInInteraction={isInInteraction}
        initialPage={Number(currentPageSharingMedia) || 1}
        onClose={onClose}
      />
    );
  } else if (document.mediaType === DocumentType.HTML) {
    return (
      <HTMLFile
        data={document.data}
        isInInteraction={isInInteraction}
        initialPage={{
          indexh: Number(currentPageSharingMedia) || 0,
          indexv: 0,
        }}
        onClose={onClose}
      />
    );
  } else if (document.mediaType === DocumentType.ZIP) {
    return (
      <HTMLZIPFile
        data={document.data}
        documentMetadata={documentMetadata}
        isInInteraction={isInInteraction}
        onClose={onClose}
      />
    );
  } else {
    return <Loader />;
  }
};
